import linkifyHtml from 'linkify-html';

export const linkify = (text) => linkifyHtml(text, {
  target: "_blank",
  rel: "noopener noreferrer"
});
